module.exports = __webpack_public_path__ + "img/logo_numeralia.e1496bbd.svg";